// Admin <-> user support messaging. There is NO user-to-user messaging: a user
// only ever has one conversation (with admins), keyed by their own uid. All writes
// go through Cloud Functions; clients only read (rules enforce this).
import { db, functions } from './firebase';
import { doc, collection, query, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

// Live conversation doc for a user (null if none). Drives the inbox indicator.
export function listenConversation(uid, cb) {
  return onSnapshot(
    doc(db, 'conversations', uid),
    s => cb(s.exists() ? { id: s.id, ...s.data() } : null),
    () => cb(null),
  );
}

// Live messages for a conversation, oldest first.
export function listenMessages(uid, cb) {
  const q = query(collection(db, 'conversations', uid, 'messages'), orderBy('createdAt', 'asc'));
  return onSnapshot(q, snap => cb(snap.docs.map(d => ({ id: d.id, ...d.data() }))), () => cb([]));
}

// Live list of all conversations for the admin queue, most recent first.
export function listenAdminConversations(cb) {
  const q = query(collection(db, 'conversations'), orderBy('lastMessageAt', 'desc'), limit(100));
  return onSnapshot(q, snap => cb(snap.docs.map(d => ({ id: d.id, ...d.data() }))), () => cb([]));
}

export async function replyToAdmin(body) {
  return httpsCallable(functions, 'replyToAdmin')({ body });
}
export async function markConversationRead(uid) {
  return httpsCallable(functions, 'markConversationRead')(uid ? { uid } : {});
}
export async function adminSendMessage(uid, body) {
  return httpsCallable(functions, 'adminSendMessage')({ uid, body });
}
export async function adminCloseConversation(uid) {
  return httpsCallable(functions, 'adminCloseConversation')({ uid });
}
